export default __webpack_public_path__ + "static/media/slider-1.fcc2faf8.jpg";